<template>
  <div class="wrp">
    <div class="top-tit">Revenue</div>
    <h1 class="clear">
      <span @click="linkTo('/revenue')">Revenue History</span>
      <span v-if="isRevenueTargetForecastActivated" @click="linkTo('/revenue-forcasting')">Revenue Forecasting</span>
      <span class="active" @click="linkTo('current')" v-if="doshiiFlag">Doshii Area</span>
      <span v-if="(oseriesFlag || tevalisFlag || redcatFlag || swiftPosFlag || squareFlag || oolioFlag) && isPro" @click="linkTo('/product-categories')">Product
        Categories</span>
      <span v-if="(oseriesFlag || squareFlag) && isPro" @click="linkTo('/terminals')">Terminals</span>
      <span v-if="(oseriesFlag || tevalisFlag || redcatFlag || swiftPosFlag || squareFlag || oolioFlag) && isPro" @click="linkTo('/revenue-group')">Revenue
        Group</span>
      <span v-if="!squareFlag && !swiftPosFlag" @click="linkTo('/accounting-categories')">Accounting Categories</span>

      <button v-if="!editStatus && editList.length > 0" @click="edit">Edit</button>
      <button v-if="editStatus" @click="save">Save <i v-if="saving" class="el-icon-loading"></i></button>
    </h1>
    <div class="revenue">

      <div v-if="!done" class="area_empty">
        <i class="el-icon-loading" style="font-size:20px"></i>
      </div>
      <div v-else-if="done && selectedUnitInfoList.length == 0 && unselectedUnitInfoList.length == 0">
        <div class="area_indexBox pad-btm-20">
          <h1>Area Not Set Yet</h1>
        </div>
      </div>
      <div v-else>
        <div class="area_indexBox" v-if="!editStatus">
          <h2 v-if="selectedUnitInfoList.length > 0">Selected Area</h2>
          <div class="boxs" v-if="selectedUnitInfoList.length > 0">
            <div class="box" v-for="(item, index) in selectedUnitInfoList" :key="index">
              {{ item.area ? `${item.name} - ${item.area} ( ${item.doshiiId} )` : 'Area Not Set Yet' }}</div>
          </div>
          <h2 v-if="unselectedUnitInfoList.length > 0">Excluded Area</h2>
          <div class="boxs" v-if="unselectedUnitInfoList.length > 0">
            <div class="box" v-for="(item, index) in unselectedUnitInfoList" :key="index">
              {{ item.area ? `${item.name} - ${item.area} ( ${item.doshiiId} )` : 'Area Not Set Yet' }}</div>
          </div>
        </div>
        <div class="area_indexBox pad-btm-20" v-if="editStatus">
          <h1>Please select area</h1>
          <h2>Multiple Choice</h2>
          <div class="boxs">
            <div class="box-check clear" @click="operateAll" :class="{ 'box-checked': allSelected }">
              All Areas
            </div>
            <div class="box-check clear" v-for="(item, index) in editList" @click="operateOne(index)" :key="index"
              :class="{ 'box-checked': item.selected }">{{ `${item.name} - ${item.area} ( ${item.doshiiId} )` }}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from '../../api/income'

export default {
  name: 'headcon',
  inject: ['reload'],
  data() {
    return {
      doshiiFlag: false,

      editStatus: false,
      editList: [],
      selectedUnitInfoList: [],
      unselectedUnitInfoList: [],
      done: false,
      saving: false,
      allSelected: false,
      isRevenueTargetForecastActivated: false,
      oseriesFlag: false,
      tevalisFlag: false,
      redcatFlag: false,
      squareFlag: false,
      swiftPosFlag: false,
      isPro: false,
    }
  },
  created() {
    var that = this
    that.getLst()

    api.progress({
      callback: (res) => {
        if (res.data.code === 0 && res.data.data.doshiiFlag) {
          this.doshiiFlag = true
        } else {
          this.linkTo('/revenue')
        }

        if (res.data.code === 0 && res.data.data.oseriesFlag) {
          this.oseriesFlag = true;
        }

        if (res.data.code === 0 && res.data.data.tevalisFlag) {
          this.tevalisFlag = true;
        }

        if (res.data.code === 0 && res.data.data.squareFlag) {
          this.squareFlag = true;
        }

        if (res.data.code === 0 && res.data.data.redcatFlag) {
          this.redcatFlag = true;
        }

        if (res.data.code === 0 && res.data.data.oolioFlag) {
          this.oolioFlag = true;
        }

        if (res.data.code === 0 && res.data.data.swiftPosFlag) {
          this.swiftPosFlag = true;
        }
      }
    })

    this.$root.$on('isPro', (isPro, others) => {
      this.isPro = isPro
      this.isRevenueTargetForecastActivated = others.isRevenueTargetForecastActivated
    })

  },
  methods: {
    operateAll() {
      var that = this
      that.editList.forEach(item => {
        item.selected = !that.allSelected ? true : false
      })
      that.allSelected = !that.allSelected
    },
    operateOne(index) {
      var that = this
      that.editList[index].selected = !that.editList[index].selected
      that.validateIfAllSElected()
    },
    validateIfAllSElected() {
      var that = this
      let lgt = 0
      that.editList.forEach(item => {
        if (item.selected)
          lgt++
      })
      if (that.editList.length === lgt) {
        that.allSelected = true
      } else {
        that.allSelected = false
      }
    },
    getLst() {
      var that = this
      that.selectedUnitInfoList = []
      that.unselectedUnitInfoList = []
      api.getAreas({
        callback: (res) => {
          let { data, code, message } = res.data
          that.done = true
          if (code === 0) {
            let empty_area_num = 0
            data.forEach(item => {
              if (!item.area)
                empty_area_num++
              /*if (item.selected) {
                  that.selectedUnitInfoList.push(item)
              } else {
                  that.unselectedUnitInfoList.push(item)
              }*/
            })
            if (empty_area_num !== data.length) {
              data.forEach(item => {
                if (item.selected) {
                  that.selectedUnitInfoList.push(item)
                } else {
                  that.unselectedUnitInfoList.push(item)
                }
              })
              that.editList = data
              that.validateIfAllSElected()
            }

          } else {
            Utils.alert('', message, 'error')
          }
        }
      })
    },
    linkTo(path) {
      if (path === 'current') {
        this.reload()
      } else {
        this.$router.push(path)
      }
    },
    edit() {
      if (this.editList.length === 0)
        return
      this.editStatus = true
    },
    save() {
      var that = this
      if (that.saving || that.editList.length === 0)
        return
      that.saving = true
      let params = []
      that.editList.forEach(item => {
        if (item.selected)
          params.push(item)
      })
      api.alterAreas({
        params: params,
        callback: (res) => {
          let { data, code, message } = res.data
          that.saving = false
          if (code === 0) {
            that.reload()
          } else {
            Utils.alert('', message, 'error')
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrp {
  width: 100%;

  .top-tit {
    font-size: 24px;
    color: var(--text-color);
    line-height: 28px;
    margin-bottom: 38px;
    font-weight: 600;
  }

  .red {
    color: #EA3796;
  }

  h1 {
    font-size: 20px;
    margin-bottom: 39px;
    font-weight: 600;
    line-height: 60px;
    margin-bottom: 27px;

    span {
      float: left;
      position: relative;
      cursor: pointer;
      color: #A6A7A9;
      margin-right: 36px;
    }

    .active {
      color: var(--text-color);

      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 110%;
        height: 2px;
        background: #EA3796;
      }
    }

    button {
      float: right;
      display: block;
      outline: none;
      background: none;
      cursor: pointer;
      width: 280px;
      height: 60px;
      border: 2px solid #EA3796;
      color: #EA3796;
      margin: 0 auto;
      font-size: 26px;

      .el-icon-loading {
        margin-left: 5px;
      }
    }
  }

  .revenue {
    padding-bottom: 50px;

    .area_indexBox {
      width: 100%;
      margin: 35px 0;
      padding: 20px 0 1px 0;
      background: var(--background-color-3);

      h1 {
        word-break: break-word;
        margin-bottom: 37px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-color);
        line-height: 28px;
        box-sizing: border-box;
        padding: 30px 0 0 0;
        text-align: center;
      }

      h2 {
        word-break: break-word;
        margin-bottom: 16px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        line-height: 28px;
        box-sizing: border-box;
        padding: 0 10px;
      }

      .boxs {
        margin-bottom: 46px;
        border-right: 1px solid #5F5F5F;
        border-left: 1px solid #5F5F5F;
        border-top: 1px solid #5F5F5F;
      }

      .box {
        word-break: break-word;
        border-bottom: 1px solid #5F5F5F;
        box-sizing: border-box;
        padding: 14px 0 14px 10px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-color);
        line-height: 32px;
      }

      .box-check {
        word-break: break-word;
        border-bottom: 1px solid #5F5F5F;
        box-sizing: border-box;
        padding: 14px 0 14px 46px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-color);
        line-height: 32px;
        background-repeat: no-repeat;
        background-position: 10px center;
        background-size: 16px 16px;
        background-image: url('../../assets/p2.png');
        cursor: pointer;
      }

      .box-checked {
        background-image: url('../../assets/p1.png') !important;
      }
    }

    .pad-btm-20 {
      padding-bottom: 20px;
    }

    .area_empty {
      width: 100%;
      margin: 35px 0;
      padding: 50px 0;
      background: var(--background-color-2);
      text-align: center;
      color: var(--text-color);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/revenue/income.vue